import { render, staticRenderFns } from "./linkShareDialog.vue?vue&type=template&id=21645ed1&scoped=true"
import script from "./linkShareDialog.vue?vue&type=script&lang=js"
export * from "./linkShareDialog.vue?vue&type=script&lang=js"
import style0 from "./linkShareDialog.vue?vue&type=style&index=0&id=21645ed1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21645ed1",
  null
  
)

export default component.exports